// const API_URL = "http://127.0.0.1:8000/";
// const API_URL = "https://api.ubalance.ru/";
const API_URL = "https://api.ultrabalance.ru/";

// const DOMAIN = "localhost:8080";
// const DOMAIN = "ubalance.ru";
const DOMAIN = "ultrabalance.ru";

// const YM_ID = "106344839";
const YM_ID = "81846475";

// const TG_BOT = "ultrabalance_assistant_local_bot";
// const TG_BOT = "ultrabalance_assistant_test_bot";
const TG_BOT = "ultrabalance_assistant_bot";

// const MAPS_TOKEN = "7fbc9747-6545-40cf-985b-976fc5af0fd7";
const MAPS_TOKEN = "11c7aea1-b213-486b-9b16-a74db20b8723";

export default {
  API_URL: API_URL,
  DOMAIN: DOMAIN,
  YM_ID: YM_ID,
  TG_BOT: TG_BOT,
  MAPS_TOKEN: MAPS_TOKEN,
};
